<template>

  <!-- Backdrop / Fond de la modale, affiché seulement si openModal est true -->
  <div class="modal" @click.self="closeModal">
    <!-- Contenu de la modale -->
    <div class="modal-content">
      <div class="form-group">
        <label class="form-label">
          Option d'alimentation
          <a href="#" class="infos"
            v-b-popover.hover.top="`L'option végétarienne vous permettra de bénéficier d'une alimentation saine sans viande et sans poisson mais équilibrée en nutriments (notamment en vitamine B12, protéines et en fer). L’option sans gluten permet une alimentation sans gluten pour tous les repas. L'alimentation à indice glycémique (IG) bas vous assure que l'ensemble des repas a un faible indice glycémique`"
            title="Type d'alimentation">?</a>
        </label>

        <select class="form-input" v-model="form.option">
          <option value="none">
            Aucune
          </option>
          <option value="vegetarian">
            Végétarienne
          </option>
          <option value="gluten-free">
            Sans gluten
          </option>
          <option value="low-glycemic">
            À indice glycémique bas
          </option>
        </select>
      </div>

      <div class="form-group">
        <label class="form-label">
          Privilégier les aliments bon marché
          <a href="#" class="infos" v-b-popover.hover.top="`Plutôt des sardines que du saumon`"
            title="Privilégier les aliments bon marché">?</a>
        </label>

        <select class="form-input" v-model="form.prefer_cheap_meals">
          <option :value="true">
            Oui
          </option>
          <option :value="false">
            Non
          </option>
        </select>
      </div>

      <div class="form-group">
        <label class="form-label">
          Préférences pour le petit déjeuner
        </label>

        <select class="form-input" v-model="form.prefered_breakfast">
          <option value="either">
            Peu importe
          </option>
          <option value="salty">
            Salé
          </option>
          <option value="sweet">
            Sucré
          </option>
        </select>
      </div>

      <div class="form-group">
        <label class="form-label">
          Nombre de repas contenant de la viande par semaine
        </label>

        <select v-if="disableMeatAndFish" disabled class="form-input">
          <option selected>
            Pas de viande ni de poisson en alimentation végétarienne
          </option>
        </select>

        <select v-else class="form-input" v-model="form.nb_meat_dish_per_week">
          <option :value="0">
            Jamais
          </option>
          <option :value="1">
            1 repas
          </option>
          <option :value="2">
            2 repas
          </option>
          <option :value="3">
            3 repas
          </option>
          <option :value="4">
            4 repas
          </option>
          <option :value="5">
            5 repas
          </option>
        </select>
      </div>

      <div class="form-group">
        <label class="form-label">
          Nombre de repas contenant du poisson par semaine
        </label>

        <select v-if="disableMeatAndFish" disabled class="form-input">
          <option selected>
            Pas de viande ni de poisson en alimentation végétarienne
          </option>
        </select>

        <select v-else class="form-input" v-model="form.nb_fish_dish_per_week">
          <option :value="0">
            Jamais
          </option>
          <option :value="1">
            1 repas
          </option>
          <option :value="2">
            2 repas
          </option>
          <option :value="3">
            3 repas
          </option>
          <option :value="4">
            4 repas
          </option>
        </select>
      </div>

      <div class="form-group">
        <label class="form-label">
          Quand est-ce que je préfère manger de la viande et du poisson ?
        </label>

        <select v-if="disableMeatAndFish" disabled class="form-input">
          <option selected>
            Pas de viande ni de poisson en alimentation végétarienne
          </option>
        </select>

        <select v-else class="form-input" v-model="form.preferences_for_when_to_eat_meat_and_fish">
          <option value="either">
            Peu importe
          </option>
          <option value="lunch">
            Au déjeuner seulement
          </option>
          <option value="diner">
            Au diner seulement
          </option>
        </select>
      </div>

      <div class="form-group">
        <label class="form-label">
          Mon pays
        </label>

        <CountrySelect v-model="form.country_code" class="form-input" />
      </div>

      <div class="form-group">
        <label class="form-label">
          Lieu ou j'achète mes courses (Code postal)
          <a href="#" class="infos"
            v-b-popover.hover.top="`Nous utilisons votre code postal pour proposer des menus avec des ingrédients de vos régions`"
            title="Code postal">?</a>
        </label>

        <input class="form-input" v-model="form.zipcode">
      </div>

      <div style="display: flex; justify-content: flex-end; margin-top: 1rem; gap: 10px;">
        <button class="button" @click="closeModal">
          Fermer
        </button>

        <button class="button" @click="save">
          Sauvegarder
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import CountrySelect from "@/components/CountrySelect.vue";
import { userState } from "@/utils/store";

export default {
  name: "EditPreferencesModal",
  components: {
    CountrySelect,
  },
  props: {
    preferences: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      form: {
        option: this.preferences.option === "low-glycemic-index"
          ? "low-glycemic"
          : this.preferences.option,
        prefer_cheap_meals: this.preferences.prefer_cheap_meals,
        prefered_breakfast: this.preferences.prefered_breakfast,
        nb_meat_dish_per_week: this.preferences.nb_meat_dish_per_week,
        nb_fish_dish_per_week: this.preferences.nb_fish_dish_per_week,
        preferences_for_when_to_eat_meat_and_fish: this.preferences.preferences_for_when_to_eat_meat_and_fish,
        country_code: this.preferences.country_code,
        zipcode: this.preferences.zipcode,
      },
      saving: false,
    };
  },
  computed: {
    disableMeatAndFish() {
      // If vegetarian is selected
      return this.form.option == "vegetarian";
    }
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
    save() {
      const res = confirm("Attention ! Nous allons regénérer vos menus pour prendre en compte vos nouvelles préférences. Cela peut prendre quelques minutes. Voulez-vous continuer ?");

      if (!res) {
        return;
      }

      this.saving = true;
      userState.globalSaving = true;

      userState.savePreferences(this.form)
        .then((response) => {
          this.$emit('update', response?.consumer_account || null);
          if (response?.warning) {
            alert(response.warning);
          }
          window.location.reload();
        })
        .catch(() => {
          userState.globalSaving = false;
          this.saving = false;
        });
    },
  }
}
</script>

<style scoped>
.my-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

.my-modal-container {
  background: #fff;
  padding: 2rem;
  border-radius: 8px;
  min-width: 300px;
  max-width: 500px;
}


.share-container {
  display: flex;
  justify-content: center;
  margin-top: 1rem;
}


.share-btn {
  margin-right: 1rem;
  /* simple marge */
  text-decoration: none;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  color: #fff;
}

.facebook {
  background: #3b5998;
}

.twitter {
  background: #1da1f2;
}

.linkedin {
  background: #0077B5;
}


.grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  grid-template-columns: 1fr 2fr;
  grid-template-rows: auto;
  grid-auto-flow: row;
}
</style>
